module.exports = __webpack_public_path__ + "static/media/si-glyph-phone-fax.9140c299.svg";


//////////////////
// WEBPACK FOOTER
// ./src/si-glyph-phone-fax.svg
// module id = 105
// module chunks = 0